import { useState } from 'react';
import { Input, Space, Popover, List } from 'antd';
import Button from 'components/Button';
import { CaretDownOutlined } from '@ant-design/icons';
import './style.scss';

type FeedbackDropdownProps = {
  label: string;
  options: string[];
  onMenuClick: (item: string) => void;
  className: string;
  disabled?: boolean;
};

const FeedbackDropdown = ({
  label,
  options = [],
  onMenuClick,
  className,
  disabled,
}: FeedbackDropdownProps) => {
  const [inputValue, setInputValue] = useState('');
  const [open, setOpen] = useState(false);

  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (flag: boolean) => {
    setOpen(flag);
  };

  const handleMenuClick = (value: string) => {
    onMenuClick(value);
    setInputValue('');
    hide();
  };
  const handleAddButtonClick = () => {
    onMenuClick(inputValue);
    setInputValue('');
    hide();
  };

  const content = (
    <>
      <List
        size="small"
        className="list-items"
        dataSource={options}
        renderItem={(item) => (
          <List.Item role="button" onClick={() => handleMenuClick(item)}>
            {item}
          </List.Item>
        )}
      />
      <div className="feedback-container">
        <Input
          className="input-box"
          placeholder="Provide reason here"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <Button
          className="feedback-button"
          onClick={handleAddButtonClick}
          disabled={inputValue?.trim().length === 0}
        >
          Submit
        </Button>
      </div>
    </>
  );

  return (
    <Popover
      placement="bottomLeft"
      arrow={false}
      content={content}
      open={open}
      onOpenChange={handleOpenChange}
      trigger="click"
    >
      <Space>
        <Button className={className} disabled={disabled}>
          <div className="btn-label">
            {label}
            <CaretDownOutlined />
          </div>
        </Button>
      </Space>
    </Popover>
  );
};

export default FeedbackDropdown;
